<div class="flex h-screen overflow-hidden relative">
    <!-- Mobile Overlay -->
    @if (isMobileMenuOpen) {
        <div class="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity duration-300"
             (click)="closeMobileMenu()"></div>
    }

    <!-- Sidebar -->
    <aside [ngClass]="{
             'w-64': isSidebarOpen,
             'w-20': !isSidebarOpen,
             'translate-x-0': isMobileMenuOpen,
             '-translate-x-full': !isMobileMenuOpen,
             'lg:translate-x-0': true
           }"
           class="bg-app-primary-10 text-white transition-all duration-300 flex flex-col z-50 fixed lg:static inset-y-0 left-0">

        <!-- Sidebar Header (Logo) -->
        <div class="h-40 flex items-center justify-between px-4 border-b border-white/10 relative">
            <div class="flex items-center justify-center flex-1 min-w-0 overflow-r-hidden">
                @if (isSidebarOpen) {
                    <img src="assets/logo/logo-white.svg" alt="Logo"
                         class="transition-all duration-300 w-40 max-h-16 object-contain">
                } @else {
                    <img src="assets/logo/logo-flower.svg" alt="Logo"
                         class="transition-all duration-300 w-10 h-10 object-contain">
                }
            </div>

            <!-- Desktop Sidebar Toggle -->
            <button (click)="toggleSidebar()"
                    class="hidden lg:flex absolute -right-4 top-1/2 -translate-y-1/2 z-50 items-center justify-center w-8 h-8 rounded-full bg-app-primary-10 border border-white/10 hover:bg-app-primary-20 transition-all text-white shrink-0 shadow-lg">
                <app-icon name="chevron-right"
                          [ngClass]="{'rotate-180': isSidebarOpen}"
                          class="w-5 h-5 transition-transform duration-300"></app-icon>
            </button>
        </div>

        <!-- Sidebar Navigation -->
        <nav class="flex-1 py-6 px-4 space-y-2 overflow-y-auto overflow-x-hidden">
            <!-- Patient Links -->
            @if (authService.getUser().role === 'patient') {
                <a routerLink="/profil-uebersicht" routerLinkActive="bg-white/10" (click)="closeMobileMenu()"
                   class="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors group">
                    <app-icon name="burger" class="w-6 h-6 text-app-secondary-10 shrink-0"></app-icon>
                    <span [ngClass]="{'opacity-100': isSidebarOpen, 'opacity-0 w-0': !isSidebarOpen}"
                          class="whitespace-nowrap transition-all duration-300">Übersicht</span>
                </a>
                <a routerLink="/termine" routerLinkActive="bg-white/10" (click)="closeMobileMenu()"
                   class="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors group">
                    <app-icon name="appointment" class="w-6 h-6 text-app-secondary-10 shrink-0"></app-icon>
                    <span [ngClass]="{'opacity-100': isSidebarOpen, 'opacity-0 w-0': !isSidebarOpen}"
                          class="whitespace-nowrap transition-all duration-300">Termine</span>
                </a>
                <a routerLink="/patient-rezepte" routerLinkActive="bg-white/10" (click)="closeMobileMenu()"
                   class="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors group">
                    <app-icon name="recipe" class="w-6 h-6 text-app-secondary-10 shrink-0"></app-icon>
                    <span [ngClass]="{'opacity-100': isSidebarOpen, 'opacity-0 w-0': !isSidebarOpen}"
                          class="whitespace-nowrap transition-all duration-300">Rezepte</span>
                </a>
                <a routerLink="/meine-akte" routerLinkActive="bg-white/10" (click)="closeMobileMenu()"
                   class="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors group">
                    <app-icon name="user-file" class="w-6 h-6 text-app-secondary-10 shrink-0"></app-icon>
                    <span [ngClass]="{'opacity-100': isSidebarOpen, 'opacity-0 w-0': !isSidebarOpen}"
                          class="whitespace-nowrap transition-all duration-300">Meine Akte</span>
                </a>
            }

            <!-- Doctor Links -->
            @if (authService.getUser().role === 'doctor') {
                <a routerLink="/doctor-dashboard" routerLinkActive="bg-white/10" (click)="closeMobileMenu()"
                   class="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors group">
                    <app-icon name="burger" class="w-6 h-6 text-app-secondary-10 shrink-0"></app-icon>
                    <span [ngClass]="{'opacity-100': isSidebarOpen, 'opacity-0 w-0': !isSidebarOpen}"
                          class="whitespace-nowrap transition-all duration-300">Dashboard</span>
                </a>
                <a routerLink="/termin-administration" routerLinkActive="bg-white/10" (click)="closeMobileMenu()"
                   class="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors group">
                    <app-icon name="appointment" class="w-6 h-6 text-app-secondary-10 shrink-0"></app-icon>
                    <span [ngClass]="{'opacity-100': isSidebarOpen, 'opacity-0 w-0': !isSidebarOpen}"
                          class="whitespace-nowrap transition-all duration-300">Termine</span>
                </a>
                <a routerLink="/patienten-liste" routerLinkActive="bg-white/10" (click)="closeMobileMenu()"
                   class="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors group">
                    <app-icon name="user" class="w-6 h-6 text-app-secondary-10 shrink-0"></app-icon>
                    <span [ngClass]="{'opacity-100': isSidebarOpen, 'opacity-0 w-0': !isSidebarOpen}"
                          class="whitespace-nowrap transition-all duration-300">Patienten</span>
                </a>
                <a routerLink="/administration" routerLinkActive="bg-white/10" (click)="closeMobileMenu()"
                   class="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors group">
                    <app-icon name="settings" class="w-6 h-6 text-app-secondary-10 shrink-0"></app-icon>
                    <span [ngClass]="{'opacity-100': isSidebarOpen, 'opacity-0 w-0': !isSidebarOpen}"
                          class="whitespace-nowrap transition-all duration-300">Einstellungen</span>
                </a>
            }

            <!-- Admin Links -->
            @if (authService.getUser().role === 'admin') {
                <a routerLink="/app-administration" routerLinkActive="bg-white/10" (click)="closeMobileMenu()"
                   class="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-white/5 transition-colors group">
                    <app-icon name="user" class="w-6 h-6 text-app-secondary-10 shrink-0"></app-icon>
                    <span [ngClass]="{'opacity-100': isSidebarOpen, 'opacity-0 w-0': !isSidebarOpen}"
                          class="whitespace-nowrap transition-all duration-300">System-Admin</span>
                </a>
            }
        </nav>

        <!-- Sidebar Footer -->
        <div class="p-4 border-t border-white/10 space-y-4">
            <!-- User Info (Moved from Header) -->
            <div class="flex items-center gap-4 px-3 py-2" *ngIf="isSidebarOpen">
                <div
                    class="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center border border-white/20 shrink-0">
                    <app-icon name="user" class="w-6 h-6 text-app-secondary-10"></app-icon>
                </div>
                <div class="overflow-hidden">
                    <div
                        class="text-sm font-semibold text-white truncate">{{ authService.getUser().firstName }} {{ authService.getUser().lastName }}
                    </div>
                    <div class="text-xs text-white/60 capitalize truncate">{{ authService.getUser().role }}</div>
                </div>
            </div>

            <button (click)="logout()"
                    class="flex items-center gap-4 px-3 py-2 w-full rounded-lg hover:bg-red-500/10 text-red-400 transition-colors group">
                <app-icon name="logout" class="w-6 h-6 shrink-0"></app-icon>
                <span [ngClass]="{'opacity-100': isSidebarOpen, 'opacity-0 w-0': !isSidebarOpen}"
                      class="whitespace-nowrap transition-all duration-300">Abmelden</span>
            </button>
        </div>
    </aside>

    <!-- Main Content Area -->
    <div class="flex-1 flex flex-col overflow-hidden relative">
        <!-- Mobile Burger Menu (Floating for mobile as header is gone) -->
        <button (click)="toggleMobileMenu()"
                class="lg:hidden fixed top-4 left-4 z-30 p-3 text-app-primary-10">
            <app-icon name="burger" class="w-6 h-6"></app-icon>
        </button>

        <!-- Page Content -->
        <main class="flex-1 overflow-y-auto">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>
